(function($){

'use strict';

$( function(){

/////////////////////////////////

// Create notification markup

let createNotificationMarkup = ( notification ) => {

    if ( typeof notification !== 'object' || typeof notification.title !== 'string' || typeof notification.body !== 'string' ) {
        return '';
    }

    let { title, body } = notification;

    // TO DO: Should replace this image
    let notifcationHeaderSrc = 'https://www.adweek.com/wp-content/themes/AdWeek/assets/images/icons/favicon.ico';

    let ntfMarkup = `

    <div aria-live="polite" aria-atomic="true" style="position: relative;">

        <div class="toast mt-3 initial-position" style="position: absolute; top: 0; right: 0;">
            <div class="toast-header">
                <img src="${notifcationHeaderSrc}" class="mr-2" alt="...">
                <strong class="mr-auto">${title}</strong>
                <small></small>
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="toast-body">
                ${body}
            </div>
        </div>
    
    </div>
    `;

    return ntfMarkup;
    
}

let currentUrl = new URL(window.location);

let notificationTitle = 'Notification';
let notificationBody, notificationData;

let params = new URLSearchParams(currentUrl.search);

notificationBody = params.get('ntfBody');
notificationTitle = params.get('ntfTitle');
notificationData = params.get('ntfData');

if( ( notificationBody || notificationData ) && notificationData.length>0 ){

    let notificationMarkup = '';

    // Check for notification data in the url parameters
    
    if( notificationData && notificationData.length > 0 ) {
        var user_data = awGetUserData();

        if(notificationData == 'login' || notificationData == 'logout' || notificationData == 'corporatesubscribed' ){ 
            if ( awIsUserLoggedIn() && notificationData == 'login' && Cookies.get( 'aw_login_msg' ) !== 'true'){
                let notification = adw.notifications[notificationData];
                notificationMarkup = createNotificationMarkup( notification );
                Cookies.set( 'aw_login_msg', 'true', { expires: 365 } );
                Cookies.set( 'aw_account_access', 'true', { expires: 365 } );
                Cookies.remove('aw_logout_msg');
            }else if ( awIsUserLoggedIn() && notificationData == 'logout'){
                console.log('User Not Logout Yet');
            }else if ( !awIsUserLoggedIn() && notificationData == 'logout' && Cookies.get( 'aw_logout_msg' ) !== 'true' && Cookies.get( 'aw_account_access' ) == 'true'){
                let notification = adw.notifications[notificationData];
                notificationMarkup = createNotificationMarkup( notification );
                Cookies.set( 'aw_logout_msg', 'true', { expires: 365 } );
                Cookies.remove('aw_login_msg');
            }else if ( !awIsUserLoggedIn() && notificationData == 'login'){
                console.log('User Not Login Yet');
            }else if ( awIsUserLoggedIn() && notificationData == 'corporatesubscribed' && Cookies.get( 'aw_corporatesubscribed_msg' ) !== 'true'){
				Cookies.set( 'aw_corporatesubscribed_msg', 'true', { expires: 365 } );
				let notification = adw.notifications[notificationData];
                notificationMarkup = createNotificationMarkup( notification );
			}
        }else{
            let notification = adw.notifications[notificationData];
            notificationMarkup = createNotificationMarkup( notification );
        }
        
    
    };
    
    let showNotification = ( markup ) => {
        let navbar;
        if( document.querySelector('#aw-navbar-root') ){
            navbar = document.querySelector('#aw-navbar-root');
        } else {

            navbar = document.querySelector('.secondary-nav-container') ? document.querySelector('.secondary-nav-container') : document.querySelector('.navbar-wrapper');
        }
        
        var notificationEl = document.createElement("div");
        
        notificationEl.classList = ['container-fluid'];
        
        notificationEl.innerHTML = markup;
        
        if( typeof navbar === 'object' && navbar !== 'null' ){
            navbar?.insertAdjacentElement?.( 'afterend', notificationEl );
        }
    
        // Init Toast
    
        $('.toast').on('shown.bs.toast', function () {
            // do something...
                $('.toast').addClass('final-position');
        });
    
        $('.toast').toast({ autohide: true, delay: 6000, animation: true }).toast('show');
    }
    
    showNotification( notificationMarkup );

}

/////////////////////////////////

});

})(jQuery)